// extracted by mini-css-extract-plugin
export default {"item":"j77YI"};